import React from "react";
import SEO from "../components/SEO";
import PickupDeliveryCalculator from "../components/PickupDeliveryCalculator";
import ExtraPageBanner from "../components/ExtraPageBanner";
import { ToolPageCtaBand } from "../components/ToolPageCms";
import useExtraPageCms from "../hooks/useExtraPageCms";

export default function PickupCalculatorPage() {
  const { data } = useExtraPageCms("pickup-calculator", null);
  return (
    <>
      <SEO
        title="Pickup Calculator — Bereken pickup-prijs in Nederland | 5999Cargo"
        description="Bereken indicatief de kosten van pickup & delivery in Nederland voor uw cargo, pakket of verhuiszending richting de Caribbean — lokaal of landelijk."
        keywords="pickup calculator, pickup prijs berekenen Nederland, vracht ophalen kosten, cargo pickup Rotterdam"
      />
      <main className="min-h-screen bg-white" data-testid="pickup-calculator-page">
        <ExtraPageBanner slug="pickup-calculator" testid="pickup-calculator-banner" />
        <PickupDeliveryCalculator />
        <ToolPageCtaBand cta={data?.cta_band} testid="pickup-calculator-cta-band" />
      </main>
    </>
  );
}
